var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay_dialog no-trans"},[_c('el-dialog',{attrs:{"title":"微信支付","visible":_vm.shows,"close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.shows=$event},"closed":_vm.onclosed}},[_c('div',{staticClass:"qrcode_img"},[_c('img',{attrs:{"src":_vm.qrcode,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }